webpackJsonp([18],{

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_MorphSVGPlugin__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_MorphSVGPlugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libs_MorphSVGPlugin__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var eyes = this.el.querySelectorAll("#ninja-eyes path");
      var ninja = this.el.querySelector("#ninja");

      this.animation = new TimelineMax({ repeat: -1 }).to(eyes, 1, { x: -7 }).to(eyes, 1, { x: 7 }).to(eyes, 1, { x: 0 }).to(ninja, 2, { opacity: 0, ease: Bounce.easeOut }).to(ninja, 2, { opacity: 1, delay: 3 });

      this.animation.paused(!this.props.isActive);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.animation.paused(!nextProps.isActive);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        { ref: function ref(el) {
            return _this2.el = el;
          }, viewBox: "0 0 600 600" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "clipPath",
          { id: "ninja-clip" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M600 300c0 165.686-134.314 300-300 300S0 465.686 0 300C0 134.315 134.314 0 300 0s300 134.315 300 300" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { clipPath: "url(#ninja-clip)" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M600 300c0 165.686-134.314 300-300 300S0 465.686 0 300C0 134.315 134.314 0 300 0s300 134.315 300 300",
            fill: "#DB2121"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { id: "ninja" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M477.022 182.856l-36.066 121.297-26.62-7.914 36.068-121.298z" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M386.544 296.245l4.508-15.162 77.64 23.085-4.51 15.162z",
              fill: "#333"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M371.996 438.54l40.055-134.71 26.62 7.915-40.055 134.71z",
              fill: "#ACACAC"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M149.613 174.94l36.067 121.296-26.62 7.915-36.065-121.296z" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M135.8 319.336l-4.508-15.162 77.638-23.085 4.51 15.16z",
              fill: "#333"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M201.365 446.464l-40.054-134.71 26.62-7.914 40.054 134.71z",
              fill: "#ACACAC"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M517 601.48H83l18.89-181.91c1.86-17.96 12.43-32.44 26.33-36.08l92.2-24.14-20.75-92.51c-3.1-13.82-4.33-27.99-3.65-42.13l2.39-49.74c1.77-37 23.52-70.11 56.77-86.43 14.14-6.94 29.48-10.41 44.82-10.41s30.68 3.47 44.82 10.41c16.62 8.16 30.38 20.52 40.19 35.46s15.69 32.47 16.58 50.97l2.39 49.74c.68 14.14-.55 28.31-3.65 42.13l-20.75 92.51 92.2 24.14c13.9 3.64 24.47 18.12 26.33 36.08L517 601.48z" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M369.333 203.156v25.12c0 1.977-1.463 3.65-3.423 3.914l-58.407 7.855c-4.98.67-10.028.67-15.008 0l-58.407-7.855c-1.96-.264-3.423-1.936-3.423-3.914v-25.12c0-2.18 1.768-3.95 3.95-3.95h130.768c2.182 0 3.95 1.77 3.95 3.95z",
              fill: "#FFCC80"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M322.5 577.032l12.63 27.4-43.726 1.827-112.69-235.997 41.706-10.913 79.62 170.27 79.54-170.27 41.704 10.92z",
              fill: "#333"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M356.784 209.564l-3.94 8.09c-1.56 3.21-4.82 5.24-8.39 5.24h-24.8c-1.55 0-2.57-1.63-1.89-3.03l2.47-5.06c1.56-3.2 4.82-5.24 8.39-5.24h28.16zM243.216 209.564l3.94 8.09c1.56 3.21 4.82 5.24 8.39 5.24h24.8c1.55 0 2.57-1.63 1.89-3.03l-2.47-5.06c-1.56-3.2-4.82-5.24-8.39-5.24h-28.16z",
              fill: "#FFF"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "g",
              { id: "ninja-eyes" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                id: "ninja-eyes-right",
                d: "M346.084 216.584c0 2.43-.91 4.64-2.42 6.31h-14.13c-1.5-1.67-2.41-3.88-2.41-6.31 0-2.78 1.2-5.29 3.11-7.02h12.73c1.92 1.73 3.12 4.24 3.12 7.02z"
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
                id: "ninja-eyes-left",
                d: "M253.916 216.584c0 2.43.91 4.64 2.42 6.31h14.13c1.5-1.67 2.41-3.88 2.41-6.31 0-2.78-1.2-5.29-3.11-7.02h-12.73c-1.92 1.73-3.12 4.24-3.12 7.02z"
              })
            )
          )
        )
      );
    }
  }]);

  return _class;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (_class);

/***/ })

});


// WEBPACK FOOTER //
// 18.e9b0ebefb425f644ac14.js